import api from "../instance/axios_instance.ts";
import { SignupInterface } from "../interface/signupInterface.ts";

const SignupApi = async (newUser: SignupInterface): Promise<SignupInterface> => {
    try {
        const response = await api.post<SignupInterface>('/new_user', newUser);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export default SignupApi;